import type { ActivityIngredient } from '@apps/main/modules/recipe/ingredients';

import { getSelectedTicketQL } from '@libs/search-service-smart-search';
import type { ActivityIngredientAdapter } from '@libs/trip-planner-interfaces';
import { IngredientType } from '@libs/trip-planner-interfaces';

export function adaptActivityIngredientToItinerarySearchCriteria(
  ingredient: ActivityIngredient
): ActivityIngredientAdapter {
  return {
    ingredientType: IngredientType.Activity,
    ingredientId: ingredient.ingredientId,
    code: ingredient.code,
    offset: ingredient.offset,
    tickets: ingredient.tickets.map(getSelectedTicketQL),
  };
}
